export default class SelectList {
  constructor(public value: number, public label: string) {}
}
